import React from 'react';
import cn from 'classnames';
import { CommonUtils } from 'src/utils';
import { LazyloadImage, Element, Image } from 'src/components';
import Gallery from 'src/components/gallery';
import { ITextProps } from '../ContentText';
import styles from '../style.module.scss';
import { useViewParagraphCount } from 'src/hooks';

export interface IImageProps extends ITextProps {
    type: string;
    content: string;
    contentOrigin: string;
    width?: number;
    height?: number;
    caption?: string;
    isGif?: boolean;
    lazyLoad?: boolean;
    id?: string;
}

export default React.memo(function ContentImageSlider(props: IImageProps) {
    const {
        content,
        width = 0,
        height = 1,
        caption = '',
        contentOrigin,
        id,
    } = props;

    const title = CommonUtils.stripHtml(caption);

    return (
        <>
            <Gallery.Item
                width={width}
                height={height}
                original={contentOrigin}
                thumbnail={content}
                title={caption}
                id={id}
            >
                {({ ref, open }: { ref: any; open: any }) => (
                    <Item domRef={ref} open={open} {...props} title={title} />
                )}
            </Gallery.Item>
        </>
    );
});

interface _IImageProps extends IImageProps {
    domRef: any;
    open?: any;
}

function Item(props: _IImageProps) {
    const {
        content,
        width = 0,
        height = 1,
        // isGif = false,
        lazyLoad = true,
        type,
        index,
        domRef,
        open,
        title,
        contentId,
    } = props;

    useViewParagraphCount({ index, eleRef: domRef, type, contentId });

    return (
        <>
            <Element
                domRef={domRef}
                className={cn(
                    'image-wrapper',
                    'relative z-[1]',
                    'body-image',
                    'after:absolute after:top-0 after:left-0 after:z-[-1]',
                    'after:w-full after:h-full',
                    'after:opacity-40',
                    "after:bg-[url('https://baomoi-static.bmcdn.me/web/styles/img/logo-baomoi-gray.png')]",
                    'after:bg-[length:20%_auto]',
                    'after:bg-[position:center_50%]',
                    'after:bg-no-repeat',
                    'after:bg-[#e9ecef]',
                )}
            >
                {/* {isGif ? (
                    <Element
                        className={cn(
                            'video-native',
                            'photo',
                            '[&_video]:max-h-[80vh] [&_video]:h-full',
                        )}
                        onClick={open}
                        domRef={domRef}
                        width={width}
                        height={height}
                        style={{
                            width: 'calc(100vw - 32px)',
                            maxWidth: 586,
                            height: `calc((100vw - 32px) * ${
                                (height || 9) / (width || 16)
                            })`,
                            maxHeight: '80vh',
                        }}
                    >
                        <NativeVideo
                            className="h-full"
                            src={content}
                            lazyload={lazyLoad}
                        />
                    </Element>
                ) : ( */}
                <>
                    {lazyLoad ? (
                        <LazyloadImage
                            className={cn(styles['photo'], 'photo')}
                            src={content}
                            alt={title}
                            onClick={open}
                            domRef={domRef}
                            width={width}
                            height={height}
                            style={{
                                width: '100%',
                                paddingTop: `calc(100% * ${height / width})`,
                                height: 0,
                            }}
                        />
                    ) : (
                        <Image
                            className={cn(styles['photo'], 'photo')}
                            onClick={open}
                            ref={domRef}
                            src={content}
                            alt={title}
                            width={width}
                            height={height}
                            style={{
                                width: '100%',
                                paddingTop: `calc(100% * ${height / width})`,
                                height: 0,
                            }}
                        />
                    )}
                </>
            </Element>
        </>
    );
}
